import { PlayerAdapterErrorCode } from 'library/ts/player/adapter/enums/PlayerAdapterErrorCode';

/**
 * @copyright © Paramount Streaming
 * @author Stan Gletski
 * @description Error codes that indicate a network-caused fatal, across all three player adapters (PLBCK-8332)
 */
export const PlayerAdapterNetworkErrorCodes: ReadonlySet<string> = new Set( [
	PlayerAdapterErrorCode.HTML5_NETWORK_ERROR,
	PlayerAdapterErrorCode.HLSJS_NETWORK_ERROR,
	PlayerAdapterErrorCode.SHAKA_NETWORK_ERROR
] );